import { PaginatedDtoSchema } from "@core/data/dto/paginated.dto.ts";
import { ReportStationSummaryDtoSchema } from "@report/data/dto/report-station.dto.ts";
import * as z from "zod";

const ReportStatesGpsItemsDtoSchema = z
    .object({
        time: z.number(),
        traveled_kilometers: z.number(),
        stations: z.array(z.number()).optional(),
    })
    .readonly();

const ReportStatesGpsRowTotalDtoSchema = z
    .object({
        DESPLAZAMIENTO: ReportStatesGpsItemsDtoSchema.optional(),
        PARADA: ReportStatesGpsItemsDtoSchema.optional(),
        totals: ReportStatesGpsItemsDtoSchema,
    })
    .readonly();

const ReportStationPoisRoutesDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: ReportStatesGpsRowTotalDtoSchema,
        station: ReportStationSummaryDtoSchema,
        pagination: PaginatedDtoSchema,
    })
    .readonly();

export const ReportStatesGpsDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.record(z.string(), ReportStationPoisRoutesDtoSchema),
        totals: ReportStatesGpsRowTotalDtoSchema,
    })
    .readonly();

export type ReportStatesGpsDto = z.output<typeof ReportStatesGpsDtoSchema>;
